<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="800"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row :gutter="32">
                    <Divider orientation="left" class="text-primary">基本信息</Divider>
                    <Col span="12">
                        <FormItem label="采购标题" prop="title">
                            <Input v-model="Forms.title" clearable placeholder="采购标题" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="维保记录（零星项目）" prop="maintain_id">
                            <Select v-model="Forms.maintain_id" clearable filterable placeholder="请选择维保记录" @on-change="maintainChange">
                                <Option v-for="(item,index) in maintainList" :key="index" :value="item.maintain_id">
                                    {{item.project_name ? item.project_name + ' / ' : ''}}{{item.title}}
                                </Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="采购产品" prop="product">
                            <Select filterable clearable placeholder="采购产品" @on-change="selectProduct">
                                <Option v-for="(item,index) in productList" :key="index" :value="item.b_id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="24" v-if="Forms.product_price.length > 0">
                        <template v-for="(item, index) in Forms.product_price" :key="index">
                            <Row :gutter="16">
                                <Col span="10">
                                    <FormItem :label="'—— 产品： '+item.name + ' 单价'" :prop="'product_price.' + index + '.price'" :rules="{required: true, type:'number', message: '必填', trigger: 'blur', transform(value) { return parseFloat(value)}}">
                                        <Input v-model="item.price" type="number" class="width-100" clearable placeholder="0.00" />
                                    </FormItem>
                                </Col>
                                <Col span="10">
                                    <FormItem label="采购数量" :prop="'product_price.' + index + '.num'" :rules="{required: true, message: '必填', trigger: 'blur'}">
                                        <Input v-model="item.num" class="width-100" clearable placeholder="如:500kg" />
                                    </FormItem>
                                </Col>
                                <Col span="4">
                                    <FormItem label="操作">
                                        <a href="javascript:void(0);" @click="productDelete(index)" class="text-danger"><Icon type="md-trash" />删除</a>
                                    </FormItem>
                                </Col>
                            </Row>
                        </template>
                    </Col>
                    <Col span="12">
                        <FormItem label="供应商" prop="company_id">
                            <Select v-model="Forms.company_id" clearable filterable placeholder="供应商">
                                <Option v-for="(item,index) in companyList" :key="index" :value="item.company_id">{{item.company}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="负责人" prop="head_id">
                            <Select v-model="Forms.head_id" clearable filterable placeholder="负责人">
                                <Option v-for="(item,index) in userList" :key="index" :value="item.admin_id">{{item.real_name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="采购金额" prop="buyer_money">
                            <Input v-model="Forms.buyer_money" type="number" clearable placeholder="采购金额" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="合同金额" prop="pay_money">
                            <Input v-model="Forms.pay_money" type="number" clearable placeholder="合同金额" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="合同凭证" prop="contract">
                            <Input v-model="Forms.contract" disabled>
                                <template #append>
                                    <div class="f-center">
                                        <Upload
                                            :show-upload-list="false"
                                            :action="upload_url"
                                            :headers = "{'token': $store.state.token}"
                                            :format="['xls','xlsx','rar','zip','doc','docx','txt','jpg','jpeg','png','pdf']"
                                            :max-size="50 * 1024"
                                            :on-success="handleSuccess"
                                            :on-format-error="handleFormatError"
                                            :on-exceeded-size="handleMaxSize">
                                            <a href="javascript:void(0);" class="text-primary"><Icon type="md-cloud-upload" />上传</a>
                                        </Upload>
                                        <Divider type="vertical" />
                                        <a href="javascript:void(0);" @click="FileDelete()" class="text-danger"><Icon type="md-trash" />删除</a>
                                        <Divider type="vertical" />
                                        <a href="javascript:void(0);" @click="FileDownload(Forms.contract)" class="text-violet"><Icon type="md-download" />下载</a>
                                    </div>
                                </template>
                            </Input>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="采购描述" prop="buyer_desc">
                            <Input v-model="Forms.buyer_desc" type="textarea" :rows="6" clearable placeholder="采购描述" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="备注信息" prop="remark">
                            <Input v-model="Forms.remark" type="textarea" :rows="3" clearable placeholder="仅内部可见" />
                        </FormItem>
                    </Col>
                    <Divider orientation="left" class="text-primary">收款账户</Divider>
                    <Col span="12">
                        <FormItem label="收款账户" prop="bank_account">
                            <Input v-model="Forms.bank_account" class="width-70" clearable placeholder="" />
                            &nbsp;<Button type="primary" class="width-27" ghost @click="getAccount()">自动获取</Button>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="账户实名" prop="bank_real_name">
                            <Input v-model="Forms.bank_real_name" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开户银行" prop="bank_name">
                            <Input v-model="Forms.bank_name" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开户地址" prop="bank_address">
                            <Input v-model="Forms.bank_address" clearable placeholder="" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>
import {getSmallBuyerConfig, getSmallBuyerDetail, saveSmallBuyer} from "@/apis/dispersed";
import {getCompanyAccount} from "@/apis/company";

export default {
    name: 'SmallBuyerCreate',
    emits: ['trueHandler'],
    data () {
        return {
            title: '新增零星采购',
            isBox: false,
            maintainList: [],
            companyList: [],
            productList: [],
            userList: [],

            upload_url: this.$uploadFileApi,
            site_url: this.$siteApi,

            Forms: {
                buyer_id: '',
                maintain_id: '',
                small_project_id: '',
                company_id: '',
                product: [],
                product_price: [],
                buyer_money: '',
                pay_money: '',
                contract: '',
                head_id: '',
                buyer_desc: '',
                remark: '',
                bank_account: '',
                bank_real_name: '',
                bank_name: '',
                bank_address: ''
            },
            Rules: {
                title: [{ required: true, type: 'string', message: '请输入采购标题', trigger: 'blur' }],
                maintain_id: [{ required: true, type: 'number', message: '请选择维保记录', trigger: 'change', transform(value) { return parseInt(value) } }],
                product: [{ required: true, type: 'array', message: '请选择采购产品', trigger: 'change' }],
                company_id: [{ required: true, type: 'number', message: '请选择供应商', trigger: 'change', transform(value) { return parseInt(value) } }],
                buyer_money: [{ required: true, type: 'number', message: '请输入采购金额', trigger: 'blur', transform(value) { return parseFloat(value) } }],
                pay_money: [{ required: true, type: 'number', message: '请输入合同金额', trigger: 'blur', transform(value) { return parseFloat(value) } }],
                head_id: [{ required: true, type: 'number', message: '请选择负责人', trigger: 'change', transform(value) { return parseInt(value) } }],
                buyer_desc: [{ required: true, type: 'string', message: '请输入采购描述', trigger: 'blur' }]
            }
        }
    },
    methods: {
        maintainChange(e){
            let that = this;
            let item = that.maintainList.find(v => parseInt(v.maintain_id) === parseInt(e));
            that.Forms.small_project_id = item ? parseInt(item.small_project_id) : '';
        },
        productDelete(index){
            this.Forms.product.forEach((item,idx)=>{
                if(parseInt(item) === parseInt(this.Forms.product_price[index].b_id)){
                    this.Forms.product.splice(idx, 1);
                    this.Forms.product_price.splice(index, 1);
                }
            })
        },
        selectProduct(e){
            if(!this.Forms.product.includes(e)){
                this.productList.forEach((item)=>{
                    if(parseInt(item.b_id) === parseInt(e)){
                        this.Forms.product.push(e);
                        this.Forms.product_price.push({
                            b_id: item.b_id,
                            name: item.name,
                            num: '',
                            price: ''
                        });
                    }
                })
            }
        },
        getAccount(){
            if(!this.Forms.company_id){
                this.$Message.error({ background: true, duration: 3, content: '请选择供应商' });
                return;
            }
            getCompanyAccount(this.Forms.company_id).then(e=>{
                let data = e.data;
                this.Forms.bank_account = data.bank_account ?? '';
                this.Forms.bank_real_name = data.bank_real_name ?? '';
                this.Forms.bank_name = data.bank_name ?? '';
                this.Forms.bank_address = data.bank_address ?? '';
            })
        },
        FileDelete(){
            this.Forms.contract = "";
        },
        handleSuccess(res){
            if(res.code == 100){
                this.Forms.contract = res.data.url;
            }else{
                this.$Message.error({ background: true, duration: 3, content: res.msg });
            }
        },
        handleFormatError(){
            this.$Message.error({ background: true, duration: 3, content: '只支持 PDF | xls | xlsx | rar | zip | doc | docx | txt | jpg | jpeg | png 文件 ' });
            return false;
        },
        handleMaxSize(){
            this.$Message.error({ background: true, duration: 3, content: '文件大小不能超出 50M' });
            return false;
        },
        FileDownload(url){
            if(url){
                const fileUrl = this.site_url + url;
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.target = '_blank';
                link.setAttribute('download', fileName);
                link.click();
            }else{
                this.$Message.error({ background: true, duration: 3, content: '没有资料可下载' });
            }
        },
        GetConfig(){
            getSmallBuyerConfig().then(e=>{
                this.maintainList = e.data.maintainList ?? [];
                this.companyList = e.data.companyList ?? [];
                this.productList = e.data.productList ?? [];
                this.userList = e.data.userList ?? [];
            })
        },
        GetDetail(buyer_id){
            this.$store.commit('SET_LOADING', true);
            getSmallBuyerDetail(buyer_id).then(e=>{
                let data = e.data;
                this.Forms.buyer_id = data.buyer_id;
                this.Forms.title = data.title ?? '';
                this.Forms.maintain_id = parseInt(data.maintain_id) || '';
                this.Forms.small_project_id = parseInt(data.small_project_id) || '';
                this.Forms.company_id = parseInt(data.company_id) || '';
                this.Forms.product = data.product ? data.product : [];
                this.Forms.product_price = data.proList ? data.proList.map(v => ({
                    b_id: parseInt(v.b_id),
                    name: v.product_name || v.name || '',
                    price: v.price,
                    num: v.num
                })) : [];
                this.Forms.buyer_money = data.buyer_money;
                this.Forms.pay_money = data.pay_money;
                this.Forms.contract = data.contract;
                this.Forms.head_id = parseInt(data.head_id) || '';
                this.Forms.buyer_desc = data.buyer_desc;
                this.Forms.remark = data.remark;
                this.Forms.bank_account = data.bank_account;
                this.Forms.bank_real_name = data.bank_real_name;
                this.Forms.bank_name = data.bank_name;
                this.Forms.bank_address = data.bank_address;
            })
        },
        add(){
            this.isBox = true;
            this.GetConfig();
        },
        edit(buyer_id){
            this.isBox = true;
            this.title = '编辑零星采购';
            this.GetConfig();
            if(buyer_id) this.GetDetail(buyer_id);
        },
        FormSubmit(){
            this.$refs['Forms'].validate((valid) => {
                if(valid){
                    this.$store.commit('SET_LOADING', true);
                    saveSmallBuyer(this.Forms).then(e=>{
                        this.$Message.success({ background: true, duration: 3, content: e.msg });
                        this.FormReset();
                        this.$emit('trueHandler');
                    })
                }
            })
        },
        FormReset(){
            this.isBox = false;
            this.title = '新增零星采购';
            this.$refs['Forms'] && this.$refs['Forms'].resetFields();
            this.Forms = {
                buyer_id: '',
                maintain_id: '',
                small_project_id: '',
                company_id: '',
                product: [],
                product_price: [],
                buyer_money: '',
                pay_money: '',
                contract: '',
                head_id: '',
                buyer_desc: '',
                remark: '',
                bank_account: '',
                bank_real_name: '',
                bank_name: '',
                bank_address: ''
            };
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
